import { ActionType, PersonNotificationDto } from '@nx-ratenow/shared/models';

export interface NotificationsState {
  count: number;
  listOfNotifications: PersonNotificationDto[];
  scheduled: PersonNotificationDto[];

  actionOnNotification: {
    actionType: ActionType;
    notification: PersonNotificationDto;
  };
}

export const initialStateNotifications: NotificationsState = {
  count: null,
  listOfNotifications: null,
  scheduled: null,

  actionOnNotification: null
};
